<div class="card-base">
    <div class="card-content-login">
        <mat-progress-bar class="progress-margin login-container" color="primary" *ngIf="loading" mode="indeterminate">
        </mat-progress-bar>
        <form [formGroup]="loginForm" (ngSubmit)="login()">
            <mat-card class="card-container">
                <div class="card-content">
                    <mat-card-header>
                      <img class="image-login" src="../../../assets/images/clayer-login.png">

                    </mat-card-header>
                    <mat-card-title>
                        Seleccione su sector
                    </mat-card-title>
                    <mat-form-field class="full-width">
                        <mat-select (selectionChange)="centerChange()" formControlName="center" placeholder="Centro" autofocus required>
                            <mat-option *ngFor="let center of centers" [value]="center">
                                {{center.Name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="f.center.errors && f.center.errors.required">
                            Seleccione un centro
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                        <mat-select formControlName="sector" placeholder="Sector" required>
                            <mat-option *ngFor="let sector of sectors" [value]="sector">
                                {{sector.Name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="f.sector.errors && f.sector.errors.required">
                            Seleccione un sector
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                        <mat-select placeholder="Empresas" formControlName="companies" multiple>
                            <mat-select-trigger>
                                {{f.companies.value ? f.companies.value[0].Name : ''}}
                                <span *ngIf="f.companies.value?.length > 1" class="additional-selection">
                  (+{{f.companies.value.length - 1}} {{f.companies.value?.length === 2 ? 'otra' : 'otras'}})
                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let company of companies" [value]="company">
                                {{company.Name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="f.companies.errors && f.companies.errors.required">
                            Seleccione una empresa
                        </mat-error>
                    </mat-form-field>
                    <div style="text-align:right">
                        <button color="primary" mat-flat-button type="submit">SIGUIENTE</button>
                    </div>
                </div>
            </mat-card>
        </form>
    </div>

</div>
